import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarProdutosPesquisa(axios, parametros) {  
    parametros.operacao = 'buscarProdutosPesquisa';      

    let retorno = {};
    
    await axios.santriGET('/rest/produto', parametros, 30, false)
      .then(response => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
      })
      .catch(error => {
        retorno = Biblioteca.retornoRequisicao('S', error, undefined);
      })
  
  
      return retorno;
  }, 
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarProdutoPesquisa.js